module.exports = __webpack_public_path__ + "static/media/Group (2).2970f722.svg";